import { ClientError } from './client-error';

export class CareerProfileMissingDataError extends ClientError {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(message: string, type?: string) {
    super(message);

    this.name = 'CareerProfileMissingDataError';
  }
}
